import ELInspectionsServiceDetail from "./ELInspectionsServiceDetail";

export default ELInspectionsServiceDetail;
